// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__UBB5j","content":"Auth_content__Wh3lJ"};